import React from 'react';
import { useState, useContext } from "react";
import { ThemeContext } from '../../../App.js';

import AirPressIcon from '../../../images/AirPress.svg'

import "../../style.css";

export default function AirPressure(props) {
    const theme = useContext(ThemeContext);

    const icon = {
        position:'absolute',
        top:5,
        left:5,
        width:16,
        height:16,
        color:'rgb(25, 145, 220)'
    }

    const nameStyle = {
        marginLeft:20
    }

    const valueStyle = {
        display:'inline',
        fontSize:32,
        fontWeight:"bold",
        marginTop:5
    }

    const valueWrapper = {
        position:'relative',
        width:'100%',
        textAlign:'center',
        marginTop:10
    }

    const unitStyle = {
        display:'inline',
        fontSize:16,
        marginLeft:5
    }

    function findParam(name) {
        var params;
        console.log("AirPress:findParam:",name);

        for (var i in props.site.parameters) {
            if(props.site.parameters[i].type == name) {
                return props.site.parameters[i];
            }
        }
        console.log("AirPress:unknown type:",name);
        return null;
    }

    // Setup
    var tStatus = "Normal";
    // var param;
    var message = props.site.message;
    var value = 0;

    console.log("AirPress:site:",props.site);
    console.log("AirPress:reading:",props.reading);

    if(message != null) {
        console.log("AirPress:message:",message);

        if(message.lufft !== null) {
            if(message.lufft.airPress != null) {
                value = (message.lufft.airPress.abs).toFixed(1);
            }
        }
        
        props.reading.thresholds.forEach( threshold => {
            if(value > threshold.value) {
                tStatus = threshold.name;
            }
        })

        console.log(tStatus);

    } else {
        console.log("AirPress:No Message");
        value = 0;
        tStatus = "No Message";
    }

    return (
        <div className="card airPress">
            <img src={AirPressIcon} style={icon} alt="Air Pressure Icon"/>
            <div className="name" style={nameStyle}>{props.reading.name}</div>
            <div className="wrapper">
                <div className="reading">{value}</div>
                <div style={unitStyle}>hPa.</div>
            </div>
        </div>
    )
}